/**
 * Maximum height of the time picker popup
 */
export const timePickerMaxHeight = 256;

/**
 * Format of the text field with type="time"
 */
export const textFieldFormat = 'HH:mm';
